import { Box, Text, styled, Accordion, Stack } from '@ltvco/refresh-lib/theme';

export const FaqContainer = styled(Box)(({ theme }) => ({
  display: 'flex',
  flexDirection: 'column',
  gap: theme.spacing(1.125),
  width: '100%',
  [theme.breakpoints.down('sm')]: {
    paddingLeft: theme.spacing(2),
    paddingRight: theme.spacing(2),
  },
}));

export const HeaderContainer = styled(Stack)(({ theme }) => ({
  gap: theme.spacing(1.5),
  marginBottom: theme.spacing(0.5),
}));

export const FaqTitle = styled(Text)(({ theme }) => ({
  fontWeight: 700,
  fontSize: '16px',
  lineHeight: '24px',
  color: theme.palette.text.primary,
}));

export const SubtitleText = styled(Text)(({ theme }) => ({
  fontSize: '16px',
  lineHeight: '24px',
  color: theme.palette.text.primary,
  '& a': {
    color: theme.palette.primary.main,
    textDecoration: 'underline',
    '&:hover': {
      textDecoration: 'none',
    },
  },
}));

export const StyledAccordion = styled(Accordion)(({ theme }) => ({
  border: `1px solid ${theme.palette.divider}`,
  borderRadius: '12px !important',
  boxShadow: 'none',
  backgroundColor: theme.palette.common.white,
  margin: '0 !important',
  '&:before': {
    display: 'none',
  },
  '& .MuiAccordionSummary-root': {
    padding: '13px 16px',
    minHeight: 'unset !important',
    borderRadius: '12px',
    '&.Mui-expanded': {
      minHeight: 'unset !important',
      borderBottomLeftRadius: 0,
      borderBottomRightRadius: 0,
      borderBottom: `1px solid ${theme.palette.divider}`,
    },
  },
  '& .MuiAccordionSummary-content': {
    margin: '0 !important',
  },
  '& .MuiAccordionSummary-expandIconWrapper': {
    color: `${theme.palette.text.secondary} !important`,
    '& .MuiSvgIcon-root': {
      color: `${theme.palette.text.secondary} !important`,
      fill: `${theme.palette.text.secondary} !important`,
    },
  },
  '& .MuiSvgIcon-root': {
    color: `${theme.palette.text.secondary} !important`,
  },
  '& .MuiAccordionDetails-root': {
    padding: theme.spacing(2),
    backgroundColor: theme.palette.grey[50],
    borderBottomLeftRadius: '12px',
    borderBottomRightRadius: '12px',
  },
}));

export const QuestionText = styled(Text)(({ theme }) => ({
  fontSize: '16px',
  lineHeight: '24px',
  fontWeight: 400,
  color: theme.palette.text.primary,
}));

export const AnswerText = styled(Text)(({ theme }) => ({
  fontSize: '14px',
  lineHeight: '20px',
  color: theme.palette.text.secondary,
}));

export const AnswerList = styled('ul')(({ theme }) => ({
  margin: theme.spacing(1, 0, 0, 0),
  paddingLeft: theme.spacing(2.5),
  '& li': {
    fontSize: '14px',
    lineHeight: '22px',
    color: theme.palette.text.secondary,
    marginBottom: theme.spacing(0.5),
  },
}));

export const DisclaimerBox = styled(Box)(({ theme }) => ({
  backgroundColor: theme.palette.grey[100],
  border: `1px solid ${theme.palette.divider}`,
  borderRadius: '12px',
  padding: theme.spacing(2),
  [theme.breakpoints.down('sm')]: {
    marginBottom: theme.spacing(3),
  },
}));

export const DisclaimerText = styled(Text)(({ theme }) => ({
  fontSize: '12px',
  lineHeight: '16px',
  color: theme.palette.text.secondary,
}));
